import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { CampaignService } from "../services/Campaign.service";
import { FINANCE_INFLUENCER_QUERY_KEY } from "../contsants";

export function useDeleteInvoice(campaignInfluencerId: string) {
  const {
    mutate: deleteInvoice,
    isLoading: isDeleting,
    isSuccess: isDeleted,
    variables,
  } = useMutation<{ invoiceId: string }>({
    mutationFn: async ({ invoiceId }) => {
      return await CampaignService.deleteInvoice(
        campaignInfluencerId,
        invoiceId
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...FINANCE_INFLUENCER_QUERY_KEY(campaignInfluencerId)],
      });
      // TODO: Invalidate relevant queries here
    },
    options: {},
  });

  return {
    deleteInvoice,
    isDeleting,
    isDeleted,
    variables,
  };
}
